import { Component } from '@angular/core';
import {  NavController, NavParams,AlertController ,LoadingController, ModalController} from 'ionic-angular';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { Storage } from '@ionic/storage'
import { reorderArray } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { ProductosEditarPage } from '../../pages/productos-editar/productos-editar'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'
import { ClienteSelectPage } from '../../pages/cliente-select/cliente-select';
import { valueDisplay } from '../../models/valueDisplay.model';
import * as fromClienteSelect from './../../pages/cliente-select/state/cliente-select/cliente-select-accions'
import { Store } from '@ngrx/store';
import { State } from '../../store/app.reducer'
import { AppState } from '../../app/app.reducer';
import { CajaProvider } from '../../providers/caja/caja';

@Component({
  selector: 'reservas-grupales',
  templateUrl: 'reservas-grupales.html',
  providers: [ AuthService ]
})
export class ReservasGrupalesComponent {
  listaProductos = [];
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId
  listaReservas
  seguimientosReservasId
  tiposReservasIdControlaPrecioSi
  tiposReservasIdControlaPrecioSiValorAnterior
  tiposReservasIdControlaPrecioNoValorAnterior
  tiposReservasIdControlaPrecioNo
  reservasEstadosViajes=[]
  reservasEstadosReservas=[]
  listaProductosSeleccionados
  allItems
  buscar:string =''
  realizandoUnaVenta:boolean= true
  queHago:boolean = true
  loader
  showSelect: boolean = false;
  showSelectControlaPrecioNo: boolean = false;
  toggleSelect: boolean = false;
  modalOptions: any = {
    cssClass: 'ionselecttipe-modal'
  };
  puntosDeEncuentras = []
  puntosDeEncuentrasId
  reservasEstadosViajesId
  reservasEstadosReservasId
  clientesId
  valoresCliente: string = 'Ingresar familiar';
  listaClientes = [];
  clienteId = []
  listaProductosReservadosPorGrupos = [];
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio: ProductosPorGruposProvider,
              public servicioCompania:CompaniasProvider,
              private storage: Storage,
              public alertControllers:AlertController,
              public auth: AuthService,
              public loadingCtrl:LoadingController,
              public modalControllers: ModalController,
              public utils: UtilsProvider,
              private store:Store<State>,
              private storePedidosSalon: Store<AppState>,
              public servicioCajaProvider: CajaProvider,            ) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']

      }
    })
    this.buscarDatos()
  }

  buscarDatos(){
    this.storage.get('companiasId').then((val) => {
    this.companiasId = val
    this.servicio.buscarSeguimientosReservasGrupales(val)
    .subscribe(
      res => {
        this.listaReservas = !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
      },
      err => {
      }
    )
    this.buscarClientes(this.companiasId)
  })

  }


  reorderItems(indexes) {
    this.listaProductos = reorderArray(this.listaProductos, indexes);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductosPorGruposDragPage');
  }

  agregarAlCarrito(item) {
        if(this.seguimientosReservasId===undefined){
          this.mostrarMensajeAdvertencia('Debe seleccionar un valor en el campo grupo reservas')
          return
        }
        let productosIdBuscar = item['productosElaboradosId']
        let tipoProductoBuscar = item['tipo']

        let contarProductosConElMismoId = this.listaProductos.filter(
            item => item.productoId == productosIdBuscar && item.tipo === tipoProductoBuscar )
        if(contarProductosConElMismoId.length > 0){
            // el producto ya existe en el carrito
            return
        }

        let contarProductosproductosElaboradosIdConElMismoId = this.listaProductos.filter(
          item => item.productosElaboradosId == productosIdBuscar && item.tipo === tipoProductoBuscar )
        if(contarProductosproductosElaboradosIdConElMismoId.length > 0){
            // el producto ya existe en el carrito
            return
        }


        // el producto aun no ha sido agregado
        this.listaProductos.push(item)
        this.buscar = ''
        this.getItems(this.buscar)
        this.realizandoUnaVenta = true
      }

      onEvent(event: string, item: any){

        if (event === 'onTextChange') {

         let valor = this.getItems(this.buscar);
         if(valor){
              item = valor
        }
        }
        }

        getItems(event: any): void {
          if(!this.allItems){
            let valores = this.listaProductosSeleccionados
            this.allItems = valores;
          }
            this.listaProductosSeleccionados = this.allItems.filter((item) => {
              return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
      }

      cerrarSession(){
        this.auth.logout()
        this.navCtrl.setRoot('LoginPage');
      }

      guardar(){

        this.realizandoUnaVenta = false
        if(this.listaProductos.length>0){
          if(this.seguimientosReservasId===undefined){
              this.mostrarMensajeAdvertencia('Debe seleccionar un grupo reserva')
              this.buscar = ''
              this.getItems(this.buscar)
              this.realizandoUnaVenta = true
          }else{
            let idgrupo = this.buscarUuidGrupos()
            let seguimientosReservasId = idgrupo[0].seguimientosReservasId

            let listaProductosJson: any = this.listaProductos.map((items: any, index: number) => {
              if(items.productosPorGruposId === 0) {
                return {
                  seguimientosReservasId:   Number(seguimientosReservasId),
                  tipo: items.tipo === "E" ? "E" : "M" ,
                  productosElaboradosId: items.tipo === "E" ? Number(items.productosElaboradosId) : 0,
                  mesasId:items.tipo === "M" ? Number(items.productosElaboradosId) : 0,
                  }
                }

            })
            let listaProductosJsonResponse = listaProductosJson.filter((item)=> item !== undefined)
            for(let i=0;i<listaProductosJsonResponse.length;i++){
            this.servicio.almacenarVariosRegistrosGruposReservasPorProductos(listaProductosJsonResponse[i])
            .subscribe(
              res => {
                if(i + 1 === listaProductosJsonResponse.length) {
                  this.utils.mensajeMuestro('Grupos reservas por productos','Actualizado Exitosamente!','success')
                }
              },
              err => {
                if(i + 1 === listaProductosJsonResponse.length) {
                  this.utils.mensajeMuestro('Grupos reservas por productos','No se pudo actualizar el registro, intente luego','warning')
                }
              }
            )
            }
                      }
        }else{
          let alert = this.alertControllers.create({
            title: 'Advertencia',
            subTitle: 'Debe seleccionar un producto, verifique',
            buttons: ['Cerrar']
          });
          alert.present();
        }
        this.limpiar()
      }


      buscarUuidGrupos(){

        let data = []
        let valorComparar = Number(this.seguimientosReservasId)
        for(let k=0;k< this.listaReservas.length;k++){
          if(k === valorComparar){

            data.push({
              seguimientosReservasId : this.listaReservas[k].seguimientosReservasId
            })
            k = this.listaReservas.length + 1
          }
        }

        return data

      }

      limpiar(){
        this.listaProductos = []
        this.realizandoUnaVenta = true
        this.seguimientosReservasId = undefined
        this.buscar=''
      }
      mostrarMensajeDeError(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      mostrarMensajeAdvertencia(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Advertencia',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }


      mostrarMensajeExito(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Registro exitoso',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      procesarResultado() {
        this.limpiar()
        this.buscarDatos()
      }

      buscarporCompania(item:any){
        this.buscarReservasEstados();
        let idgrupo = this.buscarUuidGrupos()
        let seguimientosReservasId = idgrupo[0] !== undefined && idgrupo[0].seguimientosReservasId
        !== undefined ? idgrupo[0].seguimientosReservasId : 0
        if(seguimientosReservasId === 0){
          return
        }

        let dataLista = this.listaReservas[item]
        let clienteId = dataLista !== undefined && dataLista.clientesId !== undefined ?
        dataLista.clientesId : 0
        this.storage.get('companiasId').then((val)=>{
          let idgrupo = Number(seguimientosReservasId)
          this.servicio.buscarSeguimientosReservasGrupalesDrag(val,idgrupo,clienteId)
            .subscribe((data)=>{
              this.listaProductos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
              this.listaProductosReservadosPorGrupos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[1]
              this.limpiarNombreCliente()
            },(error)=>{
              console.log(error)
            })
        })

      }
      eliminarValor(item:any,i:any){
        console.log(item,i)
      }

      eliminarRegistroReservasGrupales(item,i){
        if(item.reservasGrupalesId!==0){
          item.nombreTabla = "reservasGrupales"
          if(this.listaProductosReservadosPorGrupos.length>0){
            this.utils.mensajeMuestro('Eliminar reserva grupal','No se pudo eliminar el registro no puede tener ningun cliente asociado a este valor, elimine primero los familiares agregados','warning')
            return
          }
          let nuevoItem = {
            reservasGrupalesId:item.reservasGrupalesId,
            seguimientosReservasId:0,
            clientesId:0,
            reservasPuntosDeEncuentrosId :0,
            reservasEstadosViajesId:0,
            reservasEstadosReservasId:0,
            cuentasPorCobrarId:0,
            nombreTabla:item.nombreTabla
          }
          this.servicio.eliminarEeservasGrupalesPorCompanias(nuevoItem)
          .subscribe((data)=>{
           this.listaProductos.splice(i,1)
          },(error)=>{
            console.log(error)
          })
        }else{
          this.listaProductos.splice(i,1)
        }


      }

      eliminarRegistroReservasGrupalesPorCliente(item,i){
        if(item.reservasGrupalesPorClientesId!==0){
          item.nombreTabla = "reservasGrupalesPorClientes"
          let nuevoItem = {
            reservasGrupalesPorClientesId:item.reservasGrupalesPorClientesId,
            reservasGrupalesId:0,
            clientesId:0,
            tiposReservasId:0,
            reservasPuntosDeEncuentrosId :0,
            reservasEstadosViajesId:0,
            reservasEstadosReservasId:0,
            cuentasPorCobrarId:0,
            nombreTabla:item.nombreTabla
          }
          this.servicio.eliminarRegistroReservasGrupalesPorCliente(nuevoItem)
          .subscribe((data)=>{
           this.listaProductosReservadosPorGrupos.splice(i,1)
           this.limpiarNombreCliente()
          },(error)=>{
            console.log(error)
          })
        }else{
          this.listaProductosReservadosPorGrupos.splice(i,1)
          this.limpiarNombreCliente()
          this.limpiarNombreCliente()
        }


      }
      editarProductos(item: any) {

        let modal = this.modalControllers.create(ProductosEditarPage, { item })
        modal.present();

        modal.onDidDismiss(data => {

          if (data) {

            data.name = "dataDynamicCrud"
            data.productosId = data.productoId
            data.queHago = "A"
            data.nombreTabla = "productos"

            this.servicio.actualizar(data)
            .subscribe(
              res => {
                 this.buscarDatos()
              },
              err => console.log(err)
            )
          }
        })
      }

      buscarReservasEstados(){
        this.storage.get('companiasId').then((val) => {
          this.companiasId = val
        this.servicio.buscarReservasEstados(val)
        .subscribe(
          res => {
            this.puntosDeEncuentras = JSON.parse(res['_body']).data[0]
            this.reservasEstadosViajes = JSON.parse(res['_body']).data[1]
            this.reservasEstadosReservas = JSON.parse(res['_body']).data[2]
          },
          err => {
          }
        )
      })


      }
      actualizarReservasGrupalesPorId(seguimientosReservasId:any,clientesId:any,reservasEstadosViajesId:any) {
        this.servicio.actualizarReservasGrupales(seguimientosReservasId,clientesId,reservasEstadosViajesId)
        .subscribe(
          res => {
            this.listaProductos.forEach(producto => {
              let clientesId = this.clientesId != undefined && this.clientesId.length>0
              ? this.clientesId[0] : 0
              if(clientesId === 0 && this.clientesId !== undefined) {
                clientesId = this.clientesId
              }
              let seguimientosReservasId = this.seguimientosReservasId != undefined && this.seguimientosReservasId.length>0
              ? this.seguimientosReservasId[0] : 0
              if(seguimientosReservasId === 0 && this.seguimientosReservasId !== undefined) {
                seguimientosReservasId = this.seguimientosReservasId
              }

              let companiasId = producto.companiasId != undefined && producto.companiasId.length>0
              ?  producto.companiasId[0] : 0
              if(companiasId === 0 && producto.companiasId !== undefined) {
                companiasId = producto.companiasId
              }
              if(companiasId === 0 || seguimientosReservasId === 0 || clientesId === 0) {
                return
              }

              if (companiasId !== undefined && seguimientosReservasId !== undefined && clientesId !== undefined) {
                  this.servicio.buscarSeguimientosReservasGrupalesDrag(companiasId,seguimientosReservasId,clientesId)
              .subscribe((data)=>{
                this.listaProductos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
                this.listaProductosReservadosPorGrupos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[1]
                this.limpiarNombreCliente()
              },(error)=>{
                console.log(error)
              })
              }
          });
            let valores = JSON.parse(res['_body']).data[0]
          },
          err => {
          }
        )
      }

      buscartiposReservasIdControlaPrecioNo(seguimientosReservasId: any, tiposReservasId:any) {
        this.servicio.actualizarTiposReservasControlaPrecioNo(seguimientosReservasId,tiposReservasId)
        .subscribe(
          res => {
            this.listaProductos.forEach(producto => {
              if (producto.productosPorGruposId === seguimientosReservasId) {
                  producto.tiposReservasIdControlaPrecioNo = tiposReservasId;
                  this.servicio.buscarGruposReservasProductosPorGruposDrag(producto.companiasId,producto.seguimientosReservasId)
                  .subscribe((data)=>{
                    this.listaProductos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
                  },(error)=>{
                    console.log(error)
                  })
                  return
              }
          });
            let valores = JSON.parse(res['_body']).data[0]
          },
          err => {
          }
        )
      }

      toggleSelectControlaPrecioSiOpen(item: any, i:any, tipo:any, lista:any) {
        this.showSelect = true;
        this.tiposReservasIdControlaPrecioSiValorAnterior = item.reservasEstadosViajesId
        this.seguimientosReservasId = item.seguimientosReservasId
        this.clientesId = item.clientesId
      }

      toggleSelectControlaPrecioNoOpen(item: any, i:any, tipo:any, lista:any) {
        this.showSelectControlaPrecioNo = true;
        this.tiposReservasIdControlaPrecioNoValorAnterior = item.reservasEstadosReservasId
        this.seguimientosReservasId = item.seguimientosReservasId
      }


      toggleSelectControlaPrecioSiClose() {
        this.showSelect = false;
      }

      onSelectChangeControlaPrecioSi(event: any) {
        let clientesId = this.clientesId != undefined && this.clientesId.length>0
        ? this.clientesId[0] : 0
        if(clientesId === 0 && this.clientesId !== undefined) {
          clientesId = this.clientesId
        }
        let seguimientosReservasId = this.seguimientosReservasId != undefined && this.seguimientosReservasId.length>0
        ? this.seguimientosReservasId[0] : 0
        if(seguimientosReservasId === 0 && this.seguimientosReservasId !== undefined) {
          seguimientosReservasId = this.seguimientosReservasId
        }
        let reservasEstadosViajesId = event.reservasEstadosViajesId

        if(reservasEstadosViajesId !== undefined && seguimientosReservasId!== undefined && clientesId!== undefined) {
          this.actualizarReservasGrupalesPorId(seguimientosReservasId,clientesId,reservasEstadosViajesId)
          this.showSelect = false;
          return
        }
      }

      toggleSelectControlaPrecioNoClose() {
        this.showSelectControlaPrecioNo = false;
        console.log(this.showSelectControlaPrecioNo)
      }

      onSelectChangeControlaPrecioNo(event: any) {
        let clientesId = this.clientesId != undefined && this.clientesId.length>0
        ? this.clientesId[0] : 0
        if(clientesId === 0 && this.clientesId !== undefined) {
          clientesId = this.clientesId
        }
        let seguimientosReservasId = this.seguimientosReservasId != undefined && this.seguimientosReservasId.length>0
        ? this.seguimientosReservasId[0] : 0
        if(seguimientosReservasId === 0 && this.seguimientosReservasId !== undefined) {
          seguimientosReservasId = this.seguimientosReservasId
        }
        let reservasEstadosReservasId = event.reservasEstadosReservasId

        if(reservasEstadosReservasId !== undefined && seguimientosReservasId!== undefined && clientesId!== undefined) {
          this.actualizarReservasPorReservasGrupalesPorId(seguimientosReservasId,clientesId,reservasEstadosReservasId)
          this.showSelectControlaPrecioNo = false;
          return
        }
      }

      actualizarReservasPorReservasGrupalesPorId(seguimientosReservasId:any,clientesId:any,reservasEstadosReservasId:any) {
        this.servicio.actualizarReservasPorReservasIdGrupales(seguimientosReservasId,clientesId,reservasEstadosReservasId)
        .subscribe(
          res => {
            this.listaProductos.forEach(producto => {
              let clientesId = this.clientesId != undefined && typeof  this.clientesId === "object"
              ? this.clientesId[0] : 0
              if(clientesId === 0 && this.clientesId !== undefined) {
                clientesId = this.clientesId
              }
              let seguimientosReservasId = this.seguimientosReservasId != undefined && typeof  this.seguimientosReservasId === "object"
              ? this.seguimientosReservasId[0] : 0
              if(seguimientosReservasId === 0 && this.seguimientosReservasId !== undefined) {
                seguimientosReservasId = this.seguimientosReservasId
              }

              let companiasId = producto.companiasId != undefined && typeof  producto.companiasId === "object"
              ?  producto.companiasId[0] : 0
              if(companiasId === 0 && producto.companiasId !== undefined) {
                companiasId = producto.companiasId
              }
              if(companiasId === 0 || seguimientosReservasId === 0 || clientesId === 0) {
                return
              }

              if (companiasId !== undefined && seguimientosReservasId !== undefined && clientesId !== undefined) {
                  this.servicio.buscarSeguimientosReservasGrupalesDrag(companiasId,seguimientosReservasId,clientesId)
              .subscribe((data)=>{
                this.listaProductos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
                this.listaProductosReservadosPorGrupos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[1]
                this.limpiarNombreCliente()
              },(error)=>{
                console.log(error)
              })
              }
          });
            let valores = JSON.parse(res['_body']).data[0]
          },
          err => {
          }
        )
      }

      buscarClientes(companiasId) {
        this.servicioCajaProvider.buscarClientesPorCompaniaAll(companiasId)
        .subscribe((data: any)=>{
          let clientes: any = data;
          this.listaClientes = clientes;
        })
      }

      limpiarNombreCliente() {
        this.valoresCliente = 'Ingresar familiar'
      }

      buscarClienteSelect() {
        let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
          )
        modal.present();

        modal.onDidDismiss(data => {
          if (data) {
            this.clienteId = []
            this.clienteId.push({value:data.value, display:data.display})
            let cliente: valueDisplay[] = [{
              value:data.value,
              display:data.display
            }]
            const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
            this.store.dispatch(actionClienteCaja);

            this.listaProductos.forEach((producto) => {
              const productoActualizado = { ...producto, clientesId: data.value,nombreProducto:data.display };
              this.listaProductosReservadosPorGrupos.push(productoActualizado);
          });
            this.valoresCliente = 'Ingresar familiar : ' + data.display;
            let clientesId = data.value
            this.guardarReservasGrupalesPorcliente(clientesId,this.listaProductos[0])
          }
        })
      }

      async buscarClienteStore() {
       return new Promise((resolve, reject) => {
          this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
            return resolve(clientecaja)
          })
        });
      }

      guardarReservasGrupalesPorcliente(clientesId:any,producto) {
        let reservasGrupalesId = producto.reservasGrupalesId != undefined && typeof producto.reservasGrupalesId === "object"
        ? producto.reservasGrupalesId[0] : 0
        if(reservasGrupalesId === 0 && producto.reservasGrupalesId !== undefined) {
          reservasGrupalesId = producto.reservasGrupalesId
        }

        let tiposReservasIdControlaPrecioSi = producto.tiposReservasIdControlaPrecioSi != undefined && typeof producto.tiposReservasIdControlaPrecioSi === "object"
        ? producto.tiposReservasIdControlaPrecioSi[0] : 0
        if(tiposReservasIdControlaPrecioSi === 0 && producto.tiposReservasIdControlaPrecioSi !== undefined) {
          tiposReservasIdControlaPrecioSi = producto.tiposReservasIdControlaPrecioSi
        }

        let reservasPuntosDeEncuentrosId = producto.reservasPuntosDeEncuentrosId != undefined && typeof producto.reservasPuntosDeEncuentrosId === "object"
        ? producto.reservasPuntosDeEncuentrosId[0] : 0
        if(reservasPuntosDeEncuentrosId === 0 && producto.reservasPuntosDeEncuentrosId !== undefined) {
          reservasPuntosDeEncuentrosId = producto.reservasPuntosDeEncuentrosId
        }

        let reservasEstadosViajesId = producto.reservasEstadosViajesId != undefined && typeof producto.reservasEstadosViajesId === "object"
        ? producto.reservasEstadosViajesId[0] : 0
        if(reservasEstadosViajesId === 0 && producto.reservasEstadosViajesId !== undefined) {
          reservasEstadosViajesId = producto.reservasEstadosViajesId
        }

        let reservasEstadosReservasId = producto.reservasEstadosReservasId != undefined && typeof producto.reservasEstadosReservasId === "object"
        ? producto.reservasEstadosReservasId[0] : 0
        if(reservasEstadosReservasId === 0 && producto.reservasEstadosReservasId !== undefined) {
          reservasEstadosReservasId = producto.reservasEstadosReservasId
        }

        let seguimientosReservasId = producto.seguimientosReservasId != undefined && typeof producto.seguimientosReservasId === "object"
        ? producto.seguimientosReservasId[0] : 0
        if(seguimientosReservasId === 0 && producto.seguimientosReservasId !== undefined) {
          seguimientosReservasId = producto.seguimientosReservasId
        }
        let usuariosId = producto.usuariosId

        let cuentasPorCobrarId = 0

        if (reservasGrupalesId !== undefined && clientesId !== undefined
          && tiposReservasIdControlaPrecioSi !== undefined
          && reservasPuntosDeEncuentrosId !== undefined
          && reservasEstadosViajesId !== undefined
          && reservasEstadosReservasId !== undefined
          && cuentasPorCobrarId !== undefined
          && seguimientosReservasId !== undefined
          && usuariosId !== undefined
         ) {

          this.servicio.guardarReservasGrupalesPorClientes(reservasGrupalesId,clientesId,
            tiposReservasIdControlaPrecioSi,
            reservasPuntosDeEncuentrosId,
            reservasEstadosViajesId,
            reservasEstadosReservasId,
            cuentasPorCobrarId,
            seguimientosReservasId,
            usuariosId
          )
      .subscribe((data)=>{

        let values = producto
        let companiasId = values.companiasId != undefined && typeof values.companiasId === "object"
        ? values.companiasId[0] : 0
        if(companiasId === 0 && values.companiasId !== undefined) {
          companiasId = values.companiasId
        }

        let seguimientosReservasId = values.seguimientosReservasId != undefined && typeof values.seguimientosReservasId === "object"
        ? values.seguimientosReservasId[0] : 0
        if(seguimientosReservasId === 0 && values.seguimientosReservasId !== undefined) {
          seguimientosReservasId = values.seguimientosReservasId
        }
        let reservasGrupalesId = values.reservasGrupalesId !== undefined ? values.reservasGrupalesId : 0
        if(companiasId !== undefined && seguimientosReservasId !== undefined && reservasGrupalesId!== undefined
          && reservasGrupalesId !==0
        ){

          this.servicio.buscarSeguimientosReservasGrupalesPorReserva(companiasId,
            seguimientosReservasId,
            reservasGrupalesId
          )
      .subscribe((data)=>{
        this.listaProductosReservadosPorGrupos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
        this.limpiarNombreCliente()
      })}
      },(error)=>{
        console.log(error)
      })
      }


      }
}



// WEBPACK FOOTER //
// ./src/components/reservas-grupales/reservas-grupales.ts